import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createViolationTypeItemService,
  deleteViolationTypeItemService,
  editViolationTypeItemService,
  getViolationTypeItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const violationTypeAdminContext = createContext({
  violationTypeItems: [],
  setViolationTypeItems: () => {},
  violationType: {},
  setViolationType: () => {},
  id: "",
  setId: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetViolationTypeItemList: () => {},
  handleCreateViolationTypeItem: () => {},
  handleEditViolationTypeItem: () => {},
  handleDeleteViolationTypeItem: () => {},
});

const ViolationTypeAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [violationTypeItems, setViolationTypeItems] = useState([]);
  const [violationType, setViolationType] = useState({});
  const [id, setId] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setIcon("");
    setDescription("");
  };

  // Create Violation Type Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setIcon(itemValue.icon);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details Violation Type Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setViolationType(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setViolationType({});
  };

  // Handle Get Violation Type Item List Method
  const handleGetViolationTypeItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationTypeItemsService(objData);
      if (status === 200) {
        setViolationTypeItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Violation Type Item Method
  const handleCreateViolationTypeItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createViolationTypeItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationTypeItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Violation Type Item Method
  const handleEditViolationTypeItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editViolationTypeItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationTypeItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Violation Type Item Method
  const handleDeleteViolationTypeItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteViolationTypeItemService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetViolationTypeItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <violationTypeAdminContext.Provider
      value={{
        violationTypeItems,
        setViolationTypeItems,
        violationType,
        setViolationType,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        icon,
        setIcon,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetViolationTypeItemList,
        handleCreateViolationTypeItem,
        handleEditViolationTypeItem,
        handleDeleteViolationTypeItem,
      }}
    >
      {children}
    </violationTypeAdminContext.Provider>
  );
};

export default ViolationTypeAdminContext;
